export default __webpack_public_path__ + "static/media/GHSI Filed 2023 GIS.7f637088.pdf";